export const PriceTable = (props: {
  className?: string;
  titleBeforeTable?: string;
  needHeaderOnExport?: boolean;
  children: React.ReactNode;
}) => {
  const { className, titleBeforeTable, needHeaderOnExport = true, children } = props;
  const rightColWidth = 215;
  return (
    <section
        className={needHeaderOnExport ? "" : "remove-on-export"}
        style={{ marginTop: "15px" }}
    >
      {titleBeforeTable && (
        <h3
          style={{ margin: "35px 0 25px", padding: "0 15px", fontWeight: 300 }}
        >
          {titleBeforeTable}
        </h3>
      )}
      <table
        style={{ marginBottom: 0 }}
        className={`quote-footer-table table table-lastdark table-hover order-column ${
          className ? className : ""
        }`}
      >
        <colgroup>
          <col width="auto"></col>
          <col
            width={rightColWidth + "px"}
            style={{ textAlign: "right" }}
          ></col>
        </colgroup>
        <tbody>{children}</tbody>
      </table>
    </section>
  );
};
